import { FC, ReactNode } from "react";

import { Box, Row, ChevronDownIcon, Avatar } from "@hightouch/htui";

import { useUser } from "src/contexts/user-context";
import { Logo } from "src/ui/brand";

import { Header } from "./header";
import { UserMenu } from "./user-menu";

export const LogoHeader: FC<Readonly<{ children?: ReactNode }>> = ({
  children,
}) => {
  const { user } = useUser();

  return (
    <Header>
      <Row
        align="center"
        borderWidth="hairline"
        borderStyle="solid"
        borderColor="base.border"
        color="text.tertiary"
        height="64px"
        px={12}
        width="100%"
      >
        <Row flex={1}>
          <Logo size="130px" variant="full" theme="dark" />
        </Row>
        {children}
        <Row align="center" justify="flex-end" flex={1}>
          <UserMenu
            user={user || { name: "unknown user", email: "<no email>" }}
          >
            <Row
              as="button"
              type="button"
              cursor="pointer"
              bg="transparent"
              align="center"
              borderWidth="hairline"
              borderStyle="solid"
              borderColor="rgba(255,255,255,.3)"
              borderRadius="6px"
              gap={2.5}
              justify={["center", "center", "center", "flex-start"]}
              px={[0, 0, 0, 2.5]}
              py={2}
              _hover={{
                borderColor: "rgba(255,255,255,.5)",
              }}
              _focus={{ outline: "none" }}
              _focusVisible={{ boxShadow: "outline" }}
            >
              <Avatar name={user?.name} size="sm" />
              <Box
                color="inherit"
                display={["none", "none", "none", "block"]}
                fontSize="sm"
                fontWeight={500}
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
              >
                {user?.email}
              </Box>
              <Box as={ChevronDownIcon} boxSize={3} color="text.tertiary" />
            </Row>
          </UserMenu>
        </Row>
      </Row>
    </Header>
  );
};
